import { useDecision } from '@optimizely/react-sdk';

import { handleExperimentTracking } from '../utils/track';
import { OptimizelyFlagResult, OptimizelyKey } from '../utils/types';

export const useOptimizelyFlag = (flag: OptimizelyKey): OptimizelyFlagResult => {
  const [decision] = useDecision(flag);

  handleExperimentTracking(flag, decision);

  return {
    enabled: decision.enabled,
    variables: decision.variables || {},
    variationKey: decision.variationKey || ''
  };
};
